exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".VueCarousel-inner{margin-left:-8px;margin-right:-8px}.VueCarousel-slide{padding-left:8px;padding-right:8px;user-select:auto}.carousel__item{border:1px solid #d8d8d8;border-radius:4px;background-color:#e2e2e2;height:150px}.carousel-nav{display:contents}.carousel-dots{position:absolute;display:flex;justify-content:center;width:100%;bottom:10px}", ""]);

// exports
